import React, { useEffect } from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { Package, Mail, Zap } from "lucide-react";
import { useAuth } from "../lib/auth";
import { FEE_DEFAULT } from "../lib/appDefaults";

export default function ShippingPolicy() {
  const { config } = useAuth();
  const fee = config?.entry_fee ?? FEE_DEFAULT;
  const preLaunch = config?.status === "pre_launch";
  const entryFee = preLaunch ? "the registration fee announced when registration opens" : <span className="text-white">₹{fee}</span>;
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="App" data-testid="shipping-page">
      <Navbar />

      <section className="relative grid-bg border-b border-white/10">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8 lg:px-12 py-16 sm:py-20">
          <div className="label-eyebrow mb-4">
            Last updated: 19 July 2026 · Effective 2026
          </div>
          <h1 className="font-display text-5xl sm:text-7xl text-white leading-[0.95]" data-testid="shipping-title">
            Shipping &amp; Delivery Policy
          </h1>
          <p className="mt-6 text-gray-400 max-w-2xl text-base sm:text-lg leading-relaxed">
            IdeaThon is a fully digital competition — access is delivered electronically to your account.
          </p>
        </div>
      </section>

      <section className="bg-[#080C18]">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8 lg:px-12 py-14 max-w-3xl">
          <div className="card-surface border-l-2 border-brand flex items-start gap-3 mb-10" data-testid="shipping-banner">
            <Zap className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" strokeWidth={2} />
            <p className="text-sm text-gray-300 leading-relaxed">
              <span className="text-white font-semibold">No physical goods.</span> Access to the platform is delivered <span className="text-brand">instantly</span> on successful payment.
            </p>
          </div>

          <div className="text-gray-400 leading-relaxed space-y-4 text-[15px]">
            <p>IdeaThon is a fully digital competition. No physical goods are sold or shipped.</p>
            <p>Access to the IdeaThon platform is delivered electronically to your registered account immediately upon successful payment of the {entryFee} registration fee. If you do not receive access after a successful payment, email <a href="mailto:info@noobsync.com" className="text-brand hover:underline">info@noobsync.com</a> from your registered email address and we will resolve it.</p>
            <p>Prizes for winning teams, where applicable, are disbursed electronically to the contact on file, as described in our <a href="/terms" className="text-brand hover:underline">Terms &amp; Conditions</a>.</p>
          </div>

          <div className="card-surface flex items-start gap-3 mt-12" data-testid="shipping-contact">
            <Package className="w-5 h-5 text-brand mt-0.5 flex-shrink-0" strokeWidth={2} />
            <div className="text-sm">
              <div className="text-white font-semibold mb-1">Didn&apos;t get access?</div>
              <p className="text-gray-400">
                Email us at{" "}
                <a href="mailto:info@noobsync.com" className="text-brand hover:underline inline-flex items-center gap-1">
                  <Mail className="w-3.5 h-3.5" /> info@noobsync.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
